// extracted by mini-css-extract-plugin
export default {"emote":"_2X0Ux","not-official":"_2z4a2","notOfficial":"_2z4a2","title":"_1fpVH","emote-pixel":"_3TrN2","emotePixel":"_3TrN2"};